'use client';

import { cn } from '@/lib/utils';
import type { MerchProductVariant } from '../interfaces/merch';

interface SizeSelectorProps {
  variants: MerchProductVariant[];
  selectedSize?: string;
  onSelect: (size: string) => void;
  className?: string;
}

export function SizeSelector({ variants, selectedSize, onSelect, className }: SizeSelectorProps) {
  if (variants.length === 0) return null;

  return (
    <div className={cn('space-y-3', className)}>
      <p className="text-sm font-medium tracking-wide uppercase text-muted-foreground">Talla</p>
      <div className="flex flex-wrap gap-2">
        {variants.map((variant) => {
          const outOfStock = !variant.is_available || variant.stock_quantity <= 0;
          const isSelected = selectedSize === variant.size;

          return (
            <button
              key={variant.id}
              type="button"
              disabled={outOfStock}
              onClick={() => onSelect(variant.size)}
              className={cn(
                'min-w-[3.25rem] rounded-lg border px-4 py-2.5 text-sm font-semibold transition-all',
                outOfStock &&
                  'cursor-not-allowed border-border/40 text-muted-foreground/50 line-through opacity-50',
                !outOfStock &&
                  !isSelected &&
                  'border-white/15 hover:border-[color-mix(in_srgb,var(--merch-accent)_50%,transparent)]',
                !outOfStock &&
                  isSelected &&
                  'border-[var(--merch-accent)] bg-[color-mix(in_srgb,var(--merch-accent)_15%,transparent)] text-[var(--merch-accent)]',
              )}
            >
              {variant.size}
            </button>
          );
        })}
      </div>
    </div>
  );
}
